@let showBreadcrumb = (folders$ | async)?.length > 0;
@let openedPannel = isPannelOpen();
<header class="header">
  <div class="header__content">
    @if (showBreadcrumb) {
      <evc-breadcrumb
        class="header__breadcrumb"
        [items]="breadcrumbItems$ | async"
        [loading]="loading$ | async"
        (itemSelected)="onCrumbSelected($event)"></evc-breadcrumb>
    }
    <h2 class="header__title">{{ title() }}</h2>
  </div>

  <evc-button
    data-testid="toggle-info"
    *permission="PERMISSIONS.STORAGE_READ"
    class="header__infos"
    size="small"
    type="primary"
    frame="none"
    [icon]="`info-${openedPannel ? 'fill' : 'line'}`"
    [text]="`list.menu.info.${openedPannel ? 'hide' : 'show'}` | translate"
    (click)="onInfoClicked()" />
</header>

<form
  *permission="PERMISSIONS.STORAGE_READ"
  class="filters"
  (keydown.enter)="$event.preventDefault()">
  @for (entry of filters | keyvalue; track entry.key) {
    <evc-select
      class="filters__select"
      size="md"
      [options]="entry.value.options"
      [nullable]="true"
      [placeholder]="`list.filters.${entry.key}.placeholder` | translate"
      [formControl]="entry.value.control"></evc-select>
  }
  <evc-search class="filters__search" />
</form>
